import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StandardModal from 'components/consumer/StandardModal';
import useScreen from 'hooks/useScreen';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
import PremiumDeliveryIcon from '../icons/PremiumDeliveryIcon';
const itemTitle = 'Premium In-Home Delivery';
const itemContent = 'A premium in-home service will deliver your order on a pre-scheduled date. The delivery team will move and unpack your order to the room of your choice and dispose of all packaging. Please note: Not all items are eligible for in-home service. Price dependent on your location.';
const DeliveryItem = t0 => {
  const $ = _c(11);
  const {
    openMobileModal
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PremiumDeliveryIcon color="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobileOrTablet || $[2] !== openMobileModal) {
    t2 = <KeySellingPointsBarItem icon={t1} onClick={() => {
      if (isMobileOrTablet) {
        openMobileModal({
          content: itemContent,
          icon: <PremiumDeliveryIcon color="white" />
        });
      } else {
        setIsOpen(true);
      }
    }}>{itemTitle}</KeySellingPointsBarItem>;
    $[1] = isMobileOrTablet;
    $[2] = openMobileModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PremiumDeliveryIcon color="white" />;
    t4 = () => {
      setIsOpen(false);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOpen) {
    t5 = <StandardModal isOpen={isOpen} icon={t3} onClose={t4} title={itemTitle}>{itemContent}</StandardModal>;
    $[6] = isOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
DeliveryItem.propTypes = {
  openMobileModal: PropTypes.func
};
export default DeliveryItem;